<div class="stepper-container">
  <div class="stepper">
    <div class="wrapper-progressBar">
      <ul class="progressBar">
        <li *ngFor="let step of stepperData" [class.active]="step.isActive"><mat-icon class="content">{{step.icon}}</mat-icon></li>
      </ul>
    </div>
  </div>
</div>
